/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   CurrentSearchView clusters meta reducer
 */

import type { Pins } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import type { ActionTypes } from '../../../reducers/types'
import { CLEAR_PINS, DONE_FETCHING_PINS, START_FETCHING_PINS } from '../constants/index'

export const metaReducer = combineReducers<Pins['meta'], ActionTypes>({
  fetching: handleActions(
    {
      [START_FETCHING_PINS]: () => true,
      [CLEAR_PINS]: () => false,
      [DONE_FETCHING_PINS]: () => false,
    },
    false
  ),
  fetchingKey: handleActions(
    {
      [START_FETCHING_PINS]: (state, { payload }) => payload?.key || state,
      [CLEAR_PINS]: () => null,
    },
    null as Pins['meta']['fetchingKey']
  ),
  currentKey: handleActions(
    {
      [CLEAR_PINS]: () => null,
      [DONE_FETCHING_PINS]: (state, { payload }) => payload?.key || state,
    },
    null as Pins['meta']['currentKey']
  ),
})
